<ch-breadcrumb [parts]="breadcrumb" (goTo)="(null)"></ch-breadcrumb>

<div class="card">
  <div class="card-header">
    AbTests
    <a id='abTestsListNew' [routerLink]="['/admin/ab-tests/edit']" class="btn btn-default pull-right">
      New
    </a>
  </div>
  <div class="card-block">
    <div class="table-responsive">
      <div class="loading-cont" *ngIf="loading">
        <div class="loading-spinner"></div>
      </div>
      <p class="no-items-found" *ngIf="!loading && 0 === items.length">
        No items found.
      </p>

      <table class="table table-hover" *ngIf="!loading && 0 < items.length">
        <thead>
          <tr>
            <th>
              <span class="col-name">Name</span>
            </th>
            <th>
              <span class="col-name">Is Active</span>
            </th>
            <th>
              <span class="col-name">Use Unauth ID</span>
            </th>
            <th>
              <span class="col-name">Split</span>
            </th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of items; let i = index">
            <td class="ab-test-name">
              <span>{{ item.name }}</span>
            </td>
            <td>
              <input type="checkbox" [checked]="item.isActive" onclick="return false;" />
            </td>
            <td>
              <input type="checkbox" [checked]="item.useUnauthId" onclick="return false;" />
            </td>
            <td>
              <span>{{ split(item) }}</span>
            </td>
            <td class="col-md-1">
              <a class="btn btn-primary" (click)="edit(item)"> Edit </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/ab-tests/ab-tests-list/ab-tests-list.component.html